<div class="app-l-page-wrap">
    <div class="app-l-container">
        <div class="settings-main">
            <div class="user-profile-heading">
                <h3 class="app-c-heading--h4" translate>setting.myProfile</h3>
            </div>
            <my-tabs 
                #tabGroup
                (selectedTabChange)="onTabChanged($event)"
                (keydown.arrowRight)="selectNextTab()"
                (keydown.arrowLeft)="selectPreviousTab()">
                <!-- Tab 1: Basic Details -->
                <my-tab>
                    <ng-template #myTabTitle>{{ 'setting.basicDetails' | translate }}</ng-template>
                    <div class="profile col-md-12 col-sm-12">
                        <div class="profile-upload-container">
                            <div class="profile-upload-section">
                                <div class="default-profile-image">
                                    <h2 class="default-text">
                                        {{ profileLogoName }}
                                    </h2>
                                </div>
                                <!-- uncomment it for image upload section -->
                                <!-- <div class="uploaded-image-section">
                  <img src="/assets/img/profile-logo.svg" />
                </div> -->
                                <span class="edit-button" aria-hidden="true">
                                    <svg-icon icon="profile-edit-icon"></svg-icon>
                                </span>
                            </div>
                        </div>
                        <button
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve signout-button"
                            (click)="menuService.onLogout()"
                            (keypress)="menuService.onLogout()"
                            translate>
                            <svg-icon icon="signout-icon"></svg-icon>
                            menu.signout
                        </button>
                    </div>
                    <div class="profile-details col-md-12 col-sm-12">
                        <form
                            *ngIf="!showEditPassword && !profileEditView"
                            class="form-section">
                            <div class="form-input-section">
                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.name
                                    </div>
                                    <div class="input-section">
                                        <input
                                            class="form-input disabled"
                                            [attr.aria-label]="
                                                'Full Name, ' +
                                                ('a11y.readOnlyUseEdit' | translate)
                                            "
                                            tabindex="0"
                                            id="fullname"
                                            type="text"
                                            name="fullName"
                                            [(ngModel)]="fullName"
                                            readonly />
                                        <button
                                            type="button"
                                            class="edit-button"
                                            [attr.aria-label]="
                                                'a11y.editFullName' | translate
                                            "
                                            (click)="editProfile()">
                                            <svg-icon icon="profile-edit-icon"></svg-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-input-section">
                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.email 
                                    </div>
                                    <div class="input-section">
                                        <svg-icon
                                            icon="email-icon"
                                            class="input-icon"></svg-icon>
                                        <input
                                            class="form-input input-with-icon"
                                            [attr.aria-label]="
                                                'Email, ' +
                                                ('a11y.readOnlyUseEdit' | translate)
                                            "
                                            tabindex="0"
                                            id="email"
                                            type="text"
                                            name="email"
                                            [(ngModel)]="emailChange"
                                            readonly />
                                    </div>
                                </div>
                            </div>
                            <div
                                class="form-input-section"
                                *ngIf="!disablePassword"
                                role="button"
                                tabindex="0"
                                (click)="forgetpassword()"
                                (keypress)="forgetpassword()">
                                <div class="change-password-link" translate>
                                    setting.changePassword
                                </div>
                            </div>
                        </form>

                        <form
                            *ngIf="!showEditPassword && profileEditView"
                            class="form-section">
                            <div class="form-input-section">
                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.name <span class="required-section">*</span>
                                    </div>
                                    <div class="input-section">
                                        <input
                                            class="form-input disabled"
                                            aria-label="Full Name - Mandatory field"
                                            tabindex="0"
                                            id="fullname"
                                            type="text"
                                            name="fullName"
                                            autocomplete="name"
                                            [(ngModel)]="fullName" />
                                        <span class="edit-button" aria-hidden="true">
                                            <svg-icon icon="profile-edit-icon"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-input-section">
                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.email
                                    </div>
                                    <div class="input-section">
                                        <svg-icon
                                            icon="email-icon"
                                            class="input-icon"></svg-icon>
                                        <input
                                            class="form-input input-with-icon"
                                            [attr.aria-label]="
                                                'Email, ' +
                                                ('a11y.readOnlyUseEdit' | translate)
                                            "
                                            tabindex="0"
                                            id="email"
                                            type="text"
                                            name="email"
                                            autocomplete="email"
                                            [(ngModel)]="emailChange" />
                                    </div>
                                </div>
                            </div>
                            <div
                                class="form-input-section"
                                *ngIf="!disablePassword"
                                role="button"
                                tabindex="0"
                                (click)="forgetpassword()"
                                (keypress)="forgetpassword()">
                                <div class="change-password-link" translate>
                                    setting.changePassword
                                </div>
                            </div>

                            <div class="page-section-buttons">
                                <button
                                    aria-label="Cancel"
                                    autoFocus
                                    tabindex="0"
                                    (click)="onCancel()"
                                    (keypress)="onCancel()"
                                    class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                                    translate>
                                    setting.cancel
                                </button>
                                <button
                                    aria-label="save"
                                    autoFocus
                                    tabindex="0"
                                    (click)="onSave()"
                                    (keypress)="onSave()"
                                    [ngClass]="{
                                        'disable-section': !(
                                            fullName != user?.fullName ||
                                            emailChange != user?.email
                                        )
                                    }"
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                    translate>
                                    setting.save
                                </button>
                            </div>
                        </form>

                        <div *ngIf="showEditPassword">
                            <form class="form-section">
                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.currentPassword <span class="required-section">*</span>
                                    </div>
                                    <div class="input-section">
                                        <svg-icon
                                            icon="lock-icon"
                                            alt="lock-icon"
                                            class="input-icon"></svg-icon>
                                        <input
                                            class="form-input input-with-icon"
                                            aria-label="Current Password - Mandatory field"
                                            tabindex="0"
                                            id="currentpassword"
                                            name="currentpassword"
                                            [(ngModel)]="currentpassword"
                                            name="currentpassword"
                                            autocomplete="current-password"
                                            [type]="
                                                passwordFieldType[
                                                    'currentPasswordType'
                                                ]
                                                    ? 'text'
                                                    : 'password'
                                            " />
                                        <i
                                            tabindex="0"
                                            [attr.aria-label]="
                                                passwordFieldType[
                                                    'currentPasswordType'
                                                ]
                                                    ? 'Show password'
                                                    : 'Hide password'
                                            "
                                            class="edit-button"
                                            (click)="
                                                onClickPassword(
                                                    'currentPasswordType'
                                                )
                                            "
                                            (keydown.enter)="
                                                onClickPassword(
                                                    'currentPasswordType'
                                                )
                                            "
                                            style="cursor: pointer"
                                            [ngClass]="
                                                passwordFieldType[
                                                    'currentPasswordType'
                                                ]
                                                    ? 'fa fa-eye'
                                                    : 'fa fa-eye-slash'
                                            "></i>
                                    </div>
                                </div>

                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.newPassword <span class="required-section">*</span>
                                    </div>
                                    <div class="input-section">
                                        <svg-icon
                                            icon="lock-icon"
                                            alt="lock-icon"
                                            class="input-icon"></svg-icon>
                                        <input
                                            class="form-input input-with-icon"
                                            aria-label="New Password - Mandatory field"
                                            tabindex="0"
                                            id="password"
                                            (keyup)="onChangePassword()"
                                            [type]="
                                                passwordFieldType[
                                                    'passwordType'
                                                ]
                                                    ? 'text'
                                                    : 'password'
                                            "
                                            name="password"
                                            autocomplete="password"
                                            [(ngModel)]="password"
                                            name="password" />
                                        <i
                                            tabindex="0"
                                            [attr.aria-label]="
                                                passwordFieldType[
                                                    'passwordType'
                                                ]
                                                    ? 'Show password'
                                                    : 'Hide password'
                                            "
                                            class="edit-button"
                                            (click)="
                                                onClickPassword('passwordType')
                                            "
                                            (keydown.enter)="
                                                onClickPassword('passwordType')
                                            "
                                            style="cursor: pointer"
                                            [ngClass]="
                                                passwordFieldType[
                                                    'passwordType'
                                                ]
                                                    ? 'fa fa-eye'
                                                    : 'fa fa-eye-slash'
                                            "></i>
                                    </div>
                                    <div class="input-link-button">
                                        <!-- <button class="change-password-link">Generate Password</button> -->
                                    </div>
                                </div>

                                <div class="form-input-container">
                                    <div class="form-label" translate>
                                        setting.repeatPassword <span class="required-section">*</span>
                                    </div>
                                    <div class="input-section">
                                        <svg-icon
                                            icon="lock-icon"
                                            alt="lock-icon"
                                            class="input-icon"></svg-icon>
                                        <input
                                            class="form-input input-with-icon"
                                            aria-label="Password repeat - Mandatory field"
                                            tabindex="0"
                                            id="repeatpassword"
                                            [type]="
                                                passwordFieldType[
                                                    'passwordConfirmationType'
                                                ]
                                                    ? 'text'
                                                    : 'password'
                                            "                            
                                            [(ngModel)]="passwordConfirmation"
                                            name="passwordConfirmation"
                                            autocomplete="new-password" />
                                        <i
                                            tabindex="0"
                                            [attr.aria-label]="
                                                passwordFieldType[
                                                    'passwordConfirmationType'
                                                ]
                                                    ? 'Show password'
                                                    : 'Hide password'
                                            "
                                            class="edit-button"
                                            (click)="
                                                onClickPassword(
                                                    'passwordConfirmationType'
                                                )
                                            "
                                            (keydown.enter)="
                                                onClickPassword(
                                                    'passwordConfirmationType'
                                                )
                                            "
                                            style="cursor: pointer"
                                            [ngClass]="
                                                passwordFieldType[
                                                    'passwordConfirmationType'
                                                ]
                                                    ? 'fa fa-eye'
                                                    : 'fa fa-eye-slash'
                                            "></i>
                                    </div>
                                    <div class="input-link-button">
                                        <!-- <button class="change-password-link">Copy Password</button> -->
                                    </div>
                                </div>
                                <div class="requirements-container">
                                    <h2 class="app-c-body-text--16-m" translate>
                                        setting.passwordRequirements.title
                                    </h2>
                                    <div class="requirements-contents">
                                        <ul
                                            *ngIf="
                                                !disablePassword &&
                                                showEditPassword
                                            "
                                            class="input-conditions">
                                            <li
                                                [ngClass]="
                                                    passwordValidations.lowerLetters &&
                                                    passwordValidations.upperLetters
                                                        ? 'correct'
                                                        : 'wrong'
                                                "
                                                translate>
                                                <ion-icon
                                                    src="../../../../assets/img/icons-svg/green-tick.svg"
                                                    class="condition-icon"></ion-icon>
                                                setting.passwordRequirements.caseCheck
                                            </li>
                                            <li
                                                [ngClass]="
                                                    passwordValidations.numbers
                                                        ? 'correct'
                                                        : 'wrong'
                                                "
                                                translate>
                                                <ion-icon
                                                    src="../../../../assets/img/icons-svg/green-tick.svg"
                                                    class="condition-icon"></ion-icon>
                                                setting.passwordRequirements.digit
                                            </li>
                                            <li
                                                [ngClass]="
                                                    passwordValidations.symbols
                                                        ? 'correct'
                                                        : 'wrong'
                                                "
                                                translate>
                                                <ion-icon
                                                    src="../../../../assets/img/icons-svg/green-tick.svg"
                                                    class="condition-icon"></ion-icon>
                                                setting.passwordRequirements.specialChar
                                            </li>
                                            <li
                                                [ngClass]="
                                                    passwordValidations.pwdlength
                                                        ? 'correct'
                                                        : 'wrong'
                                                "
                                                translate>
                                                <ion-icon
                                                    src="../../../../assets/img/icons-svg/green-tick.svg"
                                                    class="condition-icon"></ion-icon>
                                                setting.passwordRequirements.length
                                            </li>
                                            <li
                                                [ngClass]="
                                                    passwordValidations.notIncludeWelltrack
                                                        ? 'correct'
                                                        : 'wrong'
                                                "
                                                translate>
                                                <ion-icon
                                                    src="../../../../assets/img/icons-svg/green-tick.svg"
                                                    class="condition-icon"></ion-icon>
                                                setting.passwordRequirements.notWelltrack
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="page-section-buttons">
                                    <button
                                        aria-label="cancel"
                                        autoFocus
                                        tabindex="0"
                                        (click)="onCancel()"
                                        (keypress)="onCancel()"
                                        class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                                        translate>
                                        setting.cancel
                                    </button>
                                    <button
                                        aria-label="save"
                                        autoFocus
                                        tabindex="0"
                                        (click)="onSave()"
                                        (keypress)="onSave()"
                                        [ngClass]="{
                                            'disable-section':
                                                showEditPassword &&
                                                !isPasswordValid
                                        }"
                                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                        translate>
                                        setting.save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </my-tab>

                <!-- Tab 2: Additional Details -->
                <my-tab>
                    <ng-template #myTabTitle>{{ 'setting.additionalDetails' | translate }}</ng-template>
                    <div class="profile col-md-12 col-sm-12">
                        <div class="profile-upload-container">
                            <div class="profile-upload-section">
                                <div class="default-profile-image">
                                    <h2 class="default-text">
                                        {{ profileLogoName }}
                                    </h2>
                                </div>
                                <!-- uncomment it for image upload section -->
                                <!-- <div class="uploaded-image-section">
                              <img src="/assets/img/profile-logo.svg" />
                            </div> -->
                                <span class="edit-button" aria-hidden="true">
                                    <svg-icon icon="profile-edit-icon"></svg-icon>
                                </span>
                            </div>
                        </div>
                        <button
                            aria-label="Logout"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve signout-button"
                            (click)="menuService.onLogout()"
                            (keypress)="menuService.onLogout()"
                            translate>
                            <svg-icon icon="signout-icon"></svg-icon>
                            menu.signout
                        </button>
                    </div>
                    <div
                        class="profile-details col-md-12 col-sm-12"
                        *ngIf="user.userType === 'user'">
                        <demographic-edit
                            *ngIf="
                                user.userType === 'user' && !surveyEditMode
                            "></demographic-edit>
                        <div
                            class="myinfo-Additional-details"
                            *ngIf="surveyEditMode">
                            <p translate>
                                setting.additionalDetailsContent.0
                                <br /><br />
                            </p>
                            <p translate>setting.additionalDetailsContent.1</p>
                        </div>
                        <div
                            class="additional-details-footer-button"
                            *ngIf="!surveyEditMode">
                            <button
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve edit-btn"
                                (click)="editSurvey()"
                                aria-label="survey edit"
                                (keypress)="editSurvey()">
                                Edit
                                <svg-icon icon="profile-edit-icon"></svg-icon>
                            </button>
                        </div>
                        <div
                            class="additional-details-footer-button survey"
                            *ngIf="surveyEditMode">
                            <button
                                aria-label="survey edit confirm"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                *ngIf="surveyEditMode"
                                [routerLink]="[
                                    '/app/surveys',
                                    user.demographicFormId,
                                    'Demographic'
                                ]"
                                [queryParams]="{ path: 'app/my-settings' }"
                                translate>
                                setting.takeSurvey
                            </button>
                        </div>
                    </div>
                </my-tab>

                <!-- Tab 3: Organizational Details -->
                <my-tab>
                    <ng-template #myTabTitle>{{ 'setting.orgDetails' | translate }}</ng-template>
                    <div class="profile col-md-12 col-sm-12">
                        <div class="profile-upload-container">
                            <div class="profile-upload-section">
                                <div class="default-profile-image">
                                    <h2 class="default-text">
                                        {{ profileLogoName }}
                                    </h2>
                                </div>
                                <!-- uncomment it for image upload section -->
                                <!-- <div class="uploaded-image-section">
                                            <img src="/assets/img/profile-logo.svg" />
                                          </div> -->
                                <span class="edit-button" aria-hidden="true">
                                    <svg-icon icon="profile-edit-icon"></svg-icon>
                                </span>
                            </div>
                        </div>
                        <button
                            aria-label="logout"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve signout-button"
                            (click)="menuService.onLogout()"
                            (keypress)="menuService.onLogout()"
                            translate>
                            <svg-icon icon="signout-icon"></svg-icon
                            >menu.signout
                        </button>
                    </div>
                    <div class="profile-details col-md-12 col-sm-12">
                        <div class="org-details">
                            <ng-container *ngIf="!showOrgList && !showAssocBtn">
                                <div
                                    class="organization-details-first-main-container">
                                    <p
                                        class="organization-details-first-label"
                                        [translate]="'setting.paired'"></p>
                                    <div
                                        class="organization-details-first-output">
                                        {{ user?.primaryOrganization?.name }}
                                        <!-- <button class="edit-organization-button" (click)="changeAssociation()"><svg-icon
                        icon="profile-edit-icon"></svg-icon></button> -->
                                    </div>
                                    <div
                                        class="change-association-button"
                                        *ngIf="showInitialBtn">
                                        <h2
                                            class="change-password-link"
                                            (click)="changeAssociation()"
                                            tabindex="0"
                                            (keypress)="changeAssociation()"
                                            translate>
                                            setting.changeAssociation
                                        </h2>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="showAssocBtn">
                                <div
                                    class="organization-details-first-main-container">
                                    <div
                                        class="change-association-button"
                                        *ngIf="!showAssocBtn">
                                        <h2
                                            class="change-password-link"
                                            (click)="changeAssociation()"
                                            tabindex="0"
                                            (keypress)="changeAssociation()"
                                            translate>
                                            setting.changeAssociation
                                        </h2>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    showOrgList &&
                                    !showAssocBtn &&
                                    organizations
                                ">
                                <div
                                    class="organization-details-first-main-container">
                                    <p
                                        class="organization-details-first-label"
                                        [translate]="'setting.paired'"></p>
                                    <div class="app-c-form-group drp-down">
                                        <!-- <select
                                            class="app-c-form-control"
                                            [(ngModel)]="orgId"
                                            (selectionChange)="onChangeOrg($event.value)">
                                            <mat-option
                                                *ngFor="let organization of organizations"
                                                [value]="organization.id"
                                                class="options-container">
                                                {{ organization.name }}
                                            </option>
                                            <option [value]="'disconnect'" class="options-container">
                                                {{ 'setting.disconnect' | translate }}
                                            </option>
                                        </select> -->
                                        <div class="app-c-custom-select" [class.is-open]="isOrgOpen">
                                        <div
                                            class="app-c-select-trigger app-c-form-control"
                                            role="combobox"
                                            aria-haspopup="listbox"
                                            aria-autocomplete="none"
                                            aria-label="Select organization"
                                            aria-controls="organization-options"
                                            [attr.aria-expanded]="isOrgOpen"
                                            tabindex="0"
                                            (click)="isOrgOpen = !isOrgOpen"
                                            (keydown.enter)="isOrgOpen = !isOrgOpen"
                                            (keydown.space)="$event.preventDefault(); isOrgOpen = !isOrgOpen"
                                            (keydown.escape)="isOrgOpen = false">
                                            <span>
                                                <ng-container *ngFor="let organization of organizations">
                                                    <ng-container *ngIf="orgId === organization.id">{{ organization.name }}</ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="orgId === 'disconnect'">{{ 'setting.disconnect' | translate }}</ng-container>
                                                <ng-container *ngIf="!orgId">{{ 'Select' }}</ng-container>
                                            </span>
                                        </div>
                                        
                                        <ul id="organization-options" class="app-c-select-list" *ngIf="isOrgOpen" role="listbox" aria-label="Organization options">
                                            <li *ngFor="let organization of organizations" [class.is-selected]="orgId === organization.id"
                                                role="option"
                                                tabindex="0"
                                                [attr.aria-selected]="orgId === organization.id"
                                                (click)="orgId = organization.id; isOrgOpen = false; onChangeOrg(organization.id)"
                                                (keydown.enter)="orgId = organization.id; isOrgOpen = false; onChangeOrg(organization.id)"
                                                (keydown.space)="$event.preventDefault(); orgId = organization.id; isOrgOpen = false; onChangeOrg(organization.id)">
                                                {{ organization.name }}
                                            </li>
                                        
                                            <li [class.is-selected]="orgId === 'disconnect'"
                                                role="option"
                                                tabindex="0"
                                                [attr.aria-selected]="orgId === 'disconnect'"
                                                (click)="orgId = 'disconnect'; isOrgOpen = false; onChangeOrg('disconnect')"
                                                (keydown.enter)="orgId = 'disconnect'; isOrgOpen = false; onChangeOrg('disconnect')"
                                                (keydown.space)="$event.preventDefault(); orgId = 'disconnect'; isOrgOpen = false; onChangeOrg('disconnect')">
                                                {{ 'setting.disconnect' | translate }}
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- EAP Employer selection (hidden when user has no primary org) -->
                            <div *ngIf="isEapOrg && employers.length > 0 && user?.primaryOrganization" class="eap-employer-profile-section">
                                <hr class="eap-divider">
                                <div class="organization-details-first-main-container eap-employer-profile">
                                    <p class="organization-details-first-label">{{ 'dynamicForm.employerLabel' | translate }}</p>
                                    <div class="organization-details-first-output" *ngIf="!showEmployerEdit && selectedEmployerName">
                                        {{ selectedEmployerName }}
                                    </div>
                                    <div class="change-association-button" *ngIf="!showEmployerEdit && selectedEmployerName">
                                        <h2 class="change-password-link"
                                            (click)="showEmployerEdit = true"
                                            tabindex="0"
                                            (keypress)="showEmployerEdit = true"
                                            translate>
                                            setting.changeEmployer
                                        </h2>
                                    </div>
                                    <mat-form-field *ngIf="showEmployerEdit || !selectedEmployerName" appearance="outline" class="eap-employer-select">
                                        <input matInput
                                            [formControl]="employerSearchControl"
                                            [matAutocomplete]="employerProfileAuto"
                                            [placeholder]="'dynamicForm.employerSearchPlaceholder' | translate">
                                        <mat-autocomplete #employerProfileAuto="matAutocomplete"
                                            [displayWith]="displayEmployer"
                                            (optionSelected)="onEmployerSelected($event)">
                                            <mat-option *ngFor="let employer of filteredEmployers" [value]="employer">
                                                {{ employer.Name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="notification-wrap"
                                *ngIf="
                                    enableConsent &&
                                    !showAssocBtn &&
                                    user.userType === 'user'
                                "
                                [ngClass]="{ 'disable-section': showOrgList }">
                                <label
                                    class="checkbox-container app-c-body-text--14"
                                    translate
                                    >setting.consent
                                    <input
                                        tabindex="0"
                                        aria-label="Consent to share mental health alerts"
                                        type="checkbox"
                                        name="user-consent"
                                        id="user-consent"
                                        [(ngModel)]="consent"
                                        (ngModelChange)="
                                            onToggleReminders(
                                                'consent',
                                                consent
                                            )
                                        " />
                                    <span
                                        class="checkmark"
                                        tabindex="0"
                                        (keydown.enter)="
                                            onToggleReminders(
                                                'consent',
                                                consent
                                            )
                                        "></span>
                                </label>
                            </div>
                            <div class="associate-button-container">
                                <button
                                    tabindex="0"
                                    aria-label="association modal button"
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve associate-button"
                                    *ngIf="showAssocBtn"
                                    (click)="showAssoModal()"
                                    (keypress)="showAssoModal()"
                                    translate>
                                    blocked.noticeline1
                                </button>
                            </div>
                        </div>
                    </div>
                </my-tab>
            </my-tabs>
        </div>
    </div>
</div>
